// extracted by mini-css-extract-plugin
export default {"form":"AdminLoginPage_form__ckM9B","input":"AdminLoginPage_input__9YnP-","button":"AdminLoginPage_button__w0pHo","error":"AdminLoginPage_error__2zc+G"};